import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { setToken } from "../lib/apiClient";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleAuth() {
  const navigate = useNavigate();
  const { setUser, fetchIdentity } = useAuth();
  const done = useRef(false);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const saved = sessionStorage.getItem("g_oauth_state");
    if (!code || !state || state !== saved) {
      setErr(true);
      setTimeout(() => navigate("/login", { replace: true }), 1500);
      return;
    }
    sessionStorage.removeItem("g_oauth_state");
    (async () => {
      try {
        const redirectUri = window.location.origin + "/auth/google";
        const { data } = await api.post("/auth/google/exchange", { code, redirect_uri: redirectUri });
        setToken(data.access_token);
        setUser(data.user);
        await fetchIdentity(); // peupler identity avant le dashboard (sinon spinner infini)
        window.history.replaceState(null, "", "/auth/google");
        navigate(data.user.onboarded ? "/dashboard" : "/onboarding", { replace: true });
      } catch {
        setErr(true);
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
  }, [navigate, setUser, fetchIdentity]);

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black text-zinc-300" data-testid="google-auth-callback">
      <div className="text-center">
        <Loader2 className="w-7 h-7 text-amber-500 animate-spin mx-auto mb-3" />
        {err ? "Échec de la connexion Google…" : "Connexion en cours…"}
      </div>
    </div>
  );
}
